
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

const LoadingSubmission = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-forest">
      <Card className="w-full max-w-md bg-white">
        <CardHeader className="text-center">
          <CardTitle>Loading your submission...</CardTitle>
          <CardDescription>Please wait while we fetch your details</CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
};

export default LoadingSubmission;
